import { g as getComputedStyle } from './getComputedStyle-cPuW_mTw.js';

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

export { isScrollParent as i };
//# sourceMappingURL=isScrollParent-C6IhePsZ.js.map
